<template>
<div id="satisfaction-client-global" class="data-list-container">

    <vs-row>
        <vs-col vs-w="12">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Analyse des bons de commande les deux derniers mois</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <e-charts :key="dataupdateKey" autoresize theme="ovilia-green" :options="line" ref="line" auto-resize />
                </div>
            </div>
        </vs-col>
    </vs-row>
    <vs-row style="margin-top:10px">
        <vs-col style="padding-right:5px" vs-w="6">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Variation de satisfaction les deux derniers semaines</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="area" height="350" :options="lineAreaChartSpline.chartOptions" :series="lineAreaChartSpline.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
        <vs-col style="padding-left:5px" vs-w="6">
            <div class="vx-card">
                <div class="vx-card__header">
                    <div class="vx-card__title">
                        <h4 class>Niveau de satisfaction client</h4>
                    </div>
                </div>
                <div class="vx-card__body">
                    <vue-apex-charts :key="dataupdateKey" type="pie" height="362" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
                </div>
            </div>
        </vs-col>
    </vs-row>

</div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import VueApexCharts from "vue-apexcharts";
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/line'
import theme from './theme.json'
import indexEvaluation from "@/http/requests/evaluation/index.js";
ECharts.registerTheme("ovilia-green", theme);

export default {
    components: {
        ECharts,
        VueApexCharts
    },
    data() {
        let data = [];
        try {
            indexEvaluation.getStatClient(this.$route.params.client_id).then(response => {
                data = response.data.statCommandes;
                this.line.xAxis.data = data.map(function (item) {
                    return item[1];
                });
                this.line.series.data = data.map(function (item) {
                    return item[2];
                });
                this.line.series.data = data.map(function (item) {
                    return item[2];
                });
                this.pieChart.series = response.data.statEvaClient.map(function (item) {
                    return item[1];
                }) 
                this.lineAreaChartSpline.chartOptions.xaxis.categories = response.data.variations.map(function (item) {
                    return item[4];
                })
                this.lineAreaChartSpline.series[0].data = response.data.variations.map(function (item) {
                    return item[1];
                })
                this.lineAreaChartSpline.series[1].data = response.data.variations.map(function (item) {
                    return item[2];
                })
                this.dataupdateKey += 1;
            })
        } catch {
            this.$vs.loading.close();
            this.$vs.notify({
                time: 10000,
                title: "Erreur s'est produite l'ors de la récupération de données",
                text: "Erreur",
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circles"
            });
        }
        return {
            dataupdateKey: 0,
            line: {
                // Make gradient line here
                visualMap: [{
                    show: true,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: 0,
                    max: 400
                }],
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    data: []
                },
                yAxis: {
                    splitLine: {
                        show: false
                    },
                },
                series: {
                    type: 'line',
                    showSymbol: false,
                    data: []
                }
            },
            pieChart: {
                series: [],
                chartOptions: {
                    labels: ['Neutre', 'Satisfait', 'Non Satisfait'],
                    colors: ['#7367F0', '#28C76F', '#EA5455'],
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }]
                }
            },
            lineAreaChartSpline: {
                series: [{
                    name: 'satisfait',
                    data: []
                }, {
                    name: 'non satisfait',
                    data: []
                }],
                chartOptions: {
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    colors: ['#28C76F', '#EA5455'],
                    xaxis: {
                        type: 'datetime',
                        categories: [],
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yy HH:mm'
                        },

                    }
                }
            }
        }
    },
    watch: {},
    computed: {},
    methods: {
        loadData() {}
    },

    created() {},
    mounted() {}
};
</script>

<style >

</style>
